import { ScaleLinear, scaleLinear } from 'd3-scale';

import { getMinMaxValues } from './get-min-max-values.js';
import { type InternalRangeItem } from '../types/range-legend.internal.js';

export const getLegendScale = (
  items: InternalRangeItem[],
  containerSize: number,
  invertScale = false,
  min?: number,
  max?: number,
): ScaleLinear<number, number> => {
  const { max: parsedMax, min: parsedMin } = getMinMaxValues(items, min, max);

  const range = [0, containerSize];
  const domain = !invertScale ? [parsedMin, parsedMax] : [parsedMax, parsedMin];

  return scaleLinear().domain(domain).range(range).clamp(true);
};
